<div class="content">
  <div class="user-to-groups"  *ngIf="!isLoading() && stopLoad">
    <div class="group">Select roles</div>
    <div class="group-list add_user">
      <div class="group-list-item"
           *ngFor="let role of step.dataSource"
           (click)="flipValue(role)"
           [ngClass]="{disabledListItem: role.disabled}"
      >
        <ng-container>
          <mat-checkbox *ngIf="!role.disabled"
                        color="primary"
                        [checked]="role.isChecked" class="selectedcheckBox" aria-label="role selection"
                        (click)="clickDetected($event)"
          ></mat-checkbox>
          <div class="group-label">
            <div>{{role.name}}</div>
            <div class="smaller group-desc" *ngIf="!role.disabled">{{role.description}}</div>
          </div>
          <div class="smaller" *ngIf="role.disabled && !role.effective">Administrators cannot remove themselves from this role.</div>
          <div class="smaller" *ngIf="role.effective">This role is inherited from user group and cannot be removed.</div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading()" class="loader">
    <mat-spinner></mat-spinner>
    <p class="loader-msg">One moment...</p>
  </div>

</div>

